/**
 * French (France) Pokémon names — official localized names.
 */
const fr: Record<string, string> = {
  venusaur: "Florizarre",
  charizard: "Dracaufeu",
  "mega-charizard-x": "Méga-Dracaufeu X",
  "mega-charizard-y": "Méga-Dracaufeu Y",
  blastoise: "Tortank",
  pikachu: "Pikachu",
  "alolan-raichu": "Raichu d'Alola",
  clefable: "Mélodelfe",
  "alolan-ninetales": "Feunard d'Alola",
  wigglytuff: "Grodoudou",
  meowth: "Miaouss",
  psyduck: "Psykokwak",
  machamp: "Mackogneur",
  "galarian-rapidash": "Galopa de Galar",
  slowbro: "Flagadoss",
  dodrio: "Dodrio",
  gengar: "Ectoplasma",
  blissey: "Leveinard",
  "mr-mime": "M. Mime",
  scizor: "Cizayox",
  gyarados: "Léviator",
  "mega-gyarados": "Méga-Léviator",
  lapras: "Lokhlass",
  vaporeon: "Aquali",
  snorlax: "Ronflex",
  zapdos: "Électhor",
  moltres: "Sulfura",
  dragonite: "Dracolosse",
  mewtwox: "Méga-Mewtwo X",
  mewtwoy: "Méga-Mewtwo Y",
  "mega-mewtwo-x": "Méga-Mewtwo X",
  "mega-mewtwo-y": "Méga-Mewtwo Y",
  mew: "Mew",
  azumarill: "Azumarill",
  espeon: "Mentali",
  umbreon: "Noctali",
  mamoswine: "Mammochon",
  suicune: "Suicune",
  tyranitar: "Tyranocif",
  "ho-oh": "Ho-Oh",
  blaziken: "Braségali",
  gardevoir: "Gardevoir",
  sableye: "Ténéfix",
  absol: "Absol",
  metagross: "Métalosse",
  latias: "Latias",
  latios: "Latios",
  empoleon: "Pingoléon",
  garchomp: "Carchacrok",
  lucario: "Lucario",
  "mega-lucario": "Méga-Lucario",
  leafeon: "Phyllali",
  glaceon: "Givrali",
  darkrai: "Darkrai",
  crustle: "Crabaraque",
  zoroark: "Zoroark",
  chandelure: "Lugulabre",
  delphox: "Goupelin",
  greninja: "Amphinobi",
  talonflame: "Flambusard",
  aegislash: "Exagide",
  sylveon: "Nymphali",
  goodra: "Muplodocus",
  trevenant: "Desséliande",
  hoopa: "Hoopa",
  decidueye: "Archéduc",
  tsareena: "Sucreine",
  comfey: "Guérilande",
  mimikyu: "Mimiqui",
  dhelmise: "Sinistrail",
  buzzwole: "Mouscoto",
  zeraora: "Zeraora",
  cinderace: "Pyrobut",
  inteleon: "Lézargus",
  greedent: "Rongrigou",
  eldegoss: "Blancoton",
  cramorant: "Nigosier",
  sirfetchd: "Palarticho",
  alcremie: "Charmilly",
  falinks: "Hexadron",
  duraludon: "Duralugon",
  dragapult: "Drakéfauche",
  zacian: "Zacian",
  urshifu: "Shifours",
  meowscarada: "Matourgeon",
  pawmot: "Parmot",
  armarouge: "Carmadura",
  ceruledge: "Malvalame",
  tinkaton: "Forgerette",
  typhlosion: "Typhlosion",
  miraidon: "Miraidon",
  // Maps — names and descriptions
  "map-groudon": "Ruines Célestes de Theia",
  "map-groudon.description": "Carte 5v5 avec Groudon.",
  "map-kyogre": "Ruines Célestes de Theia",
  "map-kyogre.description": "Carte 5v5 avec Kyogre.",
  "map-rayquaza": "Ruines Célestes de Theia",
  "map-rayquaza.description": "Carte 5v5 avec Rayquaza.",
  // Neutrals (wild Pokémon / items)
  accelgor: "Accelgor",
  altaria: "Altaria",
  baltoy: "Balbuto",
  bunnelby: "Sapereau",
  escavalier: "Lançargot",
  groudon: "Groudon",
  indeedee: "Wimessir",
  kyogre: "Kyogre",
  natu: "Natu",
  rayquaza: "Rayquaza",
  regidrago: "Regidrago",
  regice: "Regice",
  regieleki: "Regieleki",
  regirock: "Regirock",
  registeel: "Registeel",
  salac: "Baie Salac",
  sitrus: "Baie Sitrus",
  xatu: "Xatu",
  // Spawn info (HTML)
  "spawn.info.groudon.boss":
    "<p>Une fois vaincu, tous les coéquipiers vivants reçoivent un <strong>buff</strong> et <strong>15 points aeos</strong>.<br>Ce buff est <strong>permanent jusqu'à ce que le porteur soit K.O.</strong>. Au K.O., le buff <strong>passe au vainqueur</strong>.<br>Il donne un <strong>boost de vitesse de score</strong>, un <strong>gros boost de dégâts</strong> et un <strong>petit bouclier</strong>.<br>Apparaît toujours à 2:00.</p>",
  "spawn.info.bunnelby.initial":
    "<p>Ils <strong>apparaissent au début de la partie</strong> et <strong>ne réapparaissent jamais</strong> une fois vaincus.</p><p>Donnent 2 points.</p>",
  "spawn.info.bunnelby.lane_940":
    "<p>Commence à apparaître à <strong>9:40</strong>.</p><p>Vaincu : <strong>2 points</strong>, réapparition après <strong>60 secondes</strong>.</p><p>Si une des <strong>premières tours</strong> de la voie est détruite, <strong>disparaît</strong>.</p>",
  "spawn.info.bunnelby.lane_920":
    "<p>Commence à apparaître à <strong>9:20</strong>.</p><p>Vaincu : <strong>2 points</strong>, réapparition après <strong>60 secondes</strong>.</p><p>Si une des <strong>premières tours</strong> de la voie est détruite, <strong>disparaît</strong>.</p>",
  "spawn.info.bunnelby.lane_915":
    "<p>Commence à apparaître à <strong>9:15</strong>.</p><p>Vaincu : <strong>2 points</strong>, réapparition après <strong>60 secondes</strong>.</p><p>Si une des <strong>premières tours</strong> de la voie est détruite, <strong>disparaît</strong>.</p>",
  "spawn.info.accelgor":
    "<p>Commence à <strong>9:45</strong>. Vaincu : <strong>4 / 7 points</strong> et <strong>buff</strong>. Réapparition après <strong>60 s</strong>. Buff <strong>70 s</strong> : <strong>-10% temps de recharge des capacités</strong>.</p>",
  "spawn.info.escavalier":
    "<p>Commence à <strong>9:45</strong>. Vaincu : <strong>4 / 7 points</strong> et <strong>buff</strong>. Réapparition après <strong>60 s</strong>. Buff <strong>70 s</strong> : <strong>dégâts d’attaque basique + ralentissement adverse</strong>.</p>",
  "spawn.info.baltoy.generic":
    "<p>Commence à <strong>9:45</strong>. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>.</p>",
  "spawn.info.baltoy.lane_940":
    "<p>Commence à <strong>9:40</strong>. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>. <strong>Première tour</strong> détruite → <strong>disparaît</strong>.</p>",
  "spawn.info.baltoy.lane_920":
    "<p>Commence à <strong>9:40</strong>. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>. <strong>Première tour</strong> détruite → <strong>disparaît</strong>.</p>",
  "spawn.info.baltoy.lane_910":
    "<p>Commence à <strong>9:10</strong>. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>. <strong>Première tour</strong> détruite → <strong>disparaît</strong>.</p>",
  "spawn.info.baltoy.lane_910_only":
    "<p>Commence à <strong>9:10</strong>. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>.</p>",
  "spawn.info.baltoy.lane_840":
    "<p>Commence à <strong>8:40</strong>. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>.</p>",
  "spawn.info.baltoy.tower":
    "<p>Apparaît quand la <strong>première tour correspondante</strong> est détruite. Vaincu : <strong>2 points</strong>. Réapparition après <strong>60 s</strong>.</p>",
  "spawn.info.regidrago":
    "<p>Apparaît <strong>au centre à 8:00</strong>. Vaincu → <strong>Altaria 1:30 après</strong>.<br>L’équipe qui le vainc gagne <strong>de l’exp pour toute l’équipe</strong>. Dernier coup : <strong>buff score</strong> et <strong>20 points</strong>.</p>",
  "spawn.info.regieleki":
    "<p>Apparaît à <strong>7:00</strong> en haut ou en bas. Vaincu → va vers la base adverse ; touche la base : <strong>20/16/12/8 points</strong> ; base vivante : <strong>buts instantanés 20/15/10/5 s</strong>.<br>Dernier coup : <strong>20 points</strong>. Réapparition <strong>2 min</strong> après.</p>",
  "spawn.info.regi.700":
    "<p>Apparaît à <strong>7:00</strong>.</p>",
  "spawn.info.xatu":
    "<p>Apparaît à <strong>9:59</strong>. Vaincu : <strong>beaucoup d’exp</strong> et <strong>2 points</strong>. <strong>Ne réapparaît pas</strong>.</p>",
  "spawn.info.natu.900":
    "<p>Apparaît à <strong>9:00</strong>.</p>",
  "spawn.info.natu.920":
    "<p>Apparaît à <strong>9:20</strong>.</p>",
  "spawn.info.indeedee.lane":
    "<p>Commence à <strong>9:30</strong> / <strong>9:35</strong>. Vaincu : réapparition <strong>60 s</strong>, <strong>5 points</strong>. <strong>Première tour</strong> détruite → <strong>disparaît</strong>.</p>",
  "spawn.info.indeedee.tower":
    "<p>Apparaît quand la <strong>première tour correspondante</strong> est détruite. Vaincu : réapparition <strong>60 s</strong>, <strong>5 points</strong>.</p>",
  "spawn.info.salac":
    "<p>Consommé : <strong>bonus vitesse 3 s</strong>. Apparition à <strong>8:30</strong>, réapparition <strong>60 s</strong> après consommation.</p>",
  "spawn.info.salac.short":
    "<p>Bonus de vitesse pendant 3 secondes.</p>",
  "spawn.info.altaria.after_regidrago":
    "<p>Apparaît <strong>1:30 après la chute de Regidrago</strong>.</p>",
  "spawn.info.altaria.rayquaza":
    "<p>Apparaît à <strong>8:00</strong>, réapparition toutes les <strong>1:30</strong>. Disparaît à <strong>2:30</strong>.</p>",
  "spawn.info.kyogre.boss":
    "<p>Vaincu : coéquipiers vivants → <strong>buff</strong>, <strong>15 points aeos</strong>, tours adverses encore debout désactivées 1:30 (pas de bouclier/régén).<br>Buff <strong>permanent jusqu’au K.O. du porteur</strong>, puis <strong>passe au vainqueur</strong>.<br><strong>Vitesse de score</strong>, <strong>régén 5%/s</strong>, <strong>petit bouclier</strong>. Apparaît à 2:00.</p>",
  "spawn.info.rayquaza.boss":
    "<p>Vaincu : équipe gagnante reçoit <strong>15 points aeos</strong>, un <strong>bouclier</strong> qui <strong>accélère le score</strong> et <strong>empêche le blocage des buts</strong>. Apparaît à 2:00.</p>",
  "spawn.info.regidrago.kyogre":
    "<p>Apparaît <strong>au centre à 8:00</strong>.</p>",
  "spawn.info.xatu.short":
    "<p>Apparaît à <strong>9:59</strong>.</p>",
  "spawn.info.indeedee.tower_break":
    "<p>Apparition après destruction de tour.</p>",
  "spawn.info.baltoy.tower_break":
    "<p>Apparition après destruction de tour.</p>",
  "spawn.info.bunnelby.lane":
    "<p>Commence à apparaître à <strong>9:40</strong>.</p>",
  "spawn.info.bunnelby.lane_920_short":
    "<p>Commence à apparaître à <strong>9:20</strong>.</p>",
  "spawn.info.bunnelby.lane_915_short":
    "<p>Commence à apparaître à <strong>9:15</strong>.</p>",
  "spawn.info.baltoy.lane_940_short":
    "<p>Commence à apparaître à <strong>9:40</strong>.</p>",
  "spawn.info.baltoy.945_short":
    "<p>Commence à apparaître à <strong>9:45</strong>.</p>",
  "spawn.info.baltoy.lane_910_short":
    "<p>Commence à apparaître à <strong>9:10</strong>.</p>",
  "spawn.info.baltoy.lane_840_short":
    "<p>Commence à apparaître à <strong>8:40</strong>.</p>",
  "spawn.info.indeedee.lane_930":
    "<p>Commence à apparaître à <strong>9:30</strong>.</p>",
  "spawn.info.indeedee.lane_935":
    "<p>Commence à apparaître à <strong>9:35</strong>.</p>",
  "spawn.info.bunnelby.points":
    "<p>Donnent 2 points.</p>",
  "spawn.info.baltoy.tower_kyogre":
    "<p>Apparaît quand la <strong>première tour correspondante</strong> est détruite.</p>",
  "spawn.info.indeedee.tower_short":
    "<p>Apparaît quand la <strong>première tour correspondante</strong> est détruite.</p>",
  // @begin move-names-i18n
  "move.acid-spray": "Bombe Acide",
  "move.acrobatics": "Acrobatie",
  "move.aerial-ace": "Aéropique",
  "move.agility": "Hâte",
  "move.air-slash": "Lame d’Air",
  "move.amnesia": "Amnésie",
  "move.anchor-shot": "Ancrage",
  "move.ancient-power": "Pouvoir Antique",
  "move.aqua-jet": "Aqua-Jet",
  "move.aqua-ring": "Anneau Hydro",
  "move.aqua-tail": "Hydro-Queue",
  "move.armor-cannon": "Canon Blindé",
  "move.assurance": "Assurance",
  "move.astonish": "Étonnement",
  "move.aurora-veil": "Voile Aurore",
  "move.avalanche": "Avalanche",
  "move.baby-doll-eyes": "Regard Touchant",
  "move.barrier": "Bouclier",
  "move.beat-up": "Baston",
  "move.belch": "Éructation",
  "move.bite": "Morsure",
  "move.bitter-blade": "Lame en Peine",
  "move.blaze": "Torche",
  "move.blaze-kick": "Pied Brûleur",
  "move.blizzard": "Blizzard",
  "move.block": "Barrage",
  "move.bone-rush": "Charge Os",
  "move.bounce": "Rebond",
  "move.branch-poke": "Tapotige",
  "move.brave-bird": "Rapace",
  "move.brutal-swing": "Centrifugifle",
  "move.bubble": "Écume",
  "move.bubble-beam": "Bulles d’O",
  "move.bulk-up": "Gonflette",
  "move.bulldoze": "Piétisol",
  "move.bullet-punch": "Pisto-Poing",
  "move.bullet-seed": "Balle Graine",
  "move.calm-mind": "Plénitude",
  "move.charge-beam": "Rayon Chargé",
  "move.charm": "Charme",
  "move.close-combat": "Close Combat",
  "move.coaching": "Coaching",
  "move.confuse-ray": "Onde Folie",
  "move.confusion": "Choc Mental",
  "move.cotton-guard": "Cotogarde",
  "move.cotton-spore": "Spore Coton",
  "move.covet": "Implore",
  "move.cross-chop": "Coup Croix",
  "move.curse": "Malédiction",
  "move.cut": "Coupe",
  "move.dark-pulse": "Vibrobscur",
  "move.dark-void": "Trou Noir",
  "move.dazzling-gleam": "Éclat Magique",
  "move.decorate": "Nappage",
  "move.defense-curl": "Boul’Armure",
  "move.detect": "Détection",
  "move.dig": "Tunnel",
  "move.disable": "Entrave",
  "move.disarming-voice": "Voix Enjôleuse",
  "move.discharge": "Coup d’Jus",
  "move.dive": "Plongée",
  "move.double-hit": "Coup Double",
  "move.double-slap": "Torgnoles",
  "move.double-team": "Reflet",
  "move.draco-meteor": "Draco-Météore",
  "move.dragon-breath": "Draco-Souffle",
  "move.dragon-cheer": "Cri Draconique",
  "move.dragon-claw": "Draco-Griffe",
  "move.dragon-dance": "Danse Draco",
  "move.dragon-pulse": "Draco-Choc",
  "move.dragon-rush": "Draco-Charge",
  "move.dragon-tail": "Draco-Queue",
  "move.draining-kiss": "Vampibaiser",
  "move.dream-eater": "Dévorêve",
  "move.drill-peck": "Bec Vrille",
  "move.dual-wingbeat": "Double Volée",
  "move.dynamic-punch": "Dynamo-Poing",
  "move.earthquake": "Séisme",
  "move.egg-bomb": "Bombe Œuf",
  "move.electro-ball": "Boule Élek",
  "move.electro-drift": "Turbo Volt",
  "move.electroweb": "Toile Élek",
  "move.ember": "Flammèche",
  "move.eruption": "Éruption",
  "move.explosive-heat-haze": "Brume Thermique Explosive",
  "move.extreme-speed": "Vitesse Extrême",
  "move.fairy-wind": "Vent Féérique",
  "move.fake-out": "Bluff",
  "move.fake-tears": "Croco Larme",
  "move.feather-dance": "Danse Plumes",
  "move.feint": "Ruse",
  "move.feint-attack": "Feinte",
  "move.fell-stinger": "Dard Mortel",
  "move.fire-blast": "Déflagration",
  "move.fire-punch": "Poing Feu",
  "move.fire-spin": "Danse Flammes",
  "move.flail": "Gigotage",
  "move.flame-burst": "Rebondifeu",
  "move.flame-charge": "Nitrocharge",
  "move.flame-wheel": "Roue de Feu",
  "move.flamethrower": "Lance-Flammes",
  "move.flare-blitz": "Boutefeu",
  "move.flash-cannon": "Luminocanon",
  "move.flip-turn": "Eau Revoir",
  "move.floral-healing": "Soin Floral",
  "move.flower-trick": "Magie Florale",
  "move.fly": "Vol",
  "move.focus-blast": "Exploforce",
  "move.follow-me": "Par Ici",
  "move.foul-play": "Tricherie",
  "move.freeze-dry": "Lyophilisation",
  "move.fury-cutter": "Taillade",
  "move.fury-swipes": "Combo-Griffe",
  "move.future-sight": "Prescience",
  "move.giga-drain": "Giga-Sangsue",
  "move.gigaton-hammer": "Marteau Mastoc",
  "move.grass-knot": "Nœud Herbe",
  "move.grassy-glide": "Gliss’Herbe",
  "move.gravity": "Gravité",
  "move.growl": "Rugissement",
  "move.gyro-ball": "Gyroballe",
  "move.headbutt": "Coup d’Boule",
  "move.heal-pulse": "Vibra Soin",
  "move.heat-wave": "Canicule",
  "move.heavy-slam": "Tacle Lourd",
  "move.helping-hand": "Coup d’Main",
  "move.hex": "Châtiment",
  "move.high-horsepower": "Cavalerie Lourde",
  "move.hone-claws": "Aiguisage",
  "move.horn-leech": "Encornebois",
  "move.hurricane": "Vent Violent",
  "move.hydro-cannon": "Hydroblast",
  "move.hydro-pump": "Hydrocanon",
  "move.hyper-beam": "Ultralaser",
  "move.hyper-voice": "Mégaphone",
  "move.hyperspace-hole": "TrouDimensionnel",
  "move.hypnosis": "Hypnose",
  "move.ice-beam": "Laser Glace",
  "move.ice-fang": "Crocs Givre",
  "move.ice-hammer": "Marteau de Glace",
  "move.ice-shard": "Éclats Glace",
  "move.icicle-crash": "Chute Glace",
  "move.icicle-spear": "Stalactite",
  "move.icy-wind": "Vent Glace",
  "move.imprison": "Possessif",
  "move.incinerate": "Calcination",
  "move.iron-defense": "Mur de Fer",
  "move.iron-head": "Tête de Fer",
  "move.jump-kick": "Pied Sauté",
  "move.karate-chop": "Poing Karaté",
  "move.knock-off": "Sabotage",
  "move.laser-focus": "Affilage",
  "move.lava-plume": "Ébullilave",
  "move.leaf-blade": "Lame Feuille",
  "move.leaf-storm": "Tempête Verte",
  "move.leaf-tornado": "Phytomixeur",
  "move.leafage": "Feuillage",
  "move.leech-life": "Vampirisme",
  "move.lick": "Léchouille",
  "move.light-screen": "Mur Lumière",
  "move.liquidation": "Aqua-Brèche",
  "move.low-sweep": "Balayette",
  "move.lunge": "Furie-Bond",
  "move.luster-purge": "Lumi-Éclat",
  "move.mach-punch": "Mach Punch",
  "move.magical-leaf": "Feuille Magik",
  "move.magnet-rise": "Vol Magnétik",
  "move.mean-look": "Regard Noir",
  "move.mega-punch": "Ultimapoing",
  "move.megahorn": "Mégacorne",
  "move.metal-claw": "Griffe Acier",
  "move.meteor-mash": "Poing Météore",
  "move.mist-ball": "Ball’Brume",
  "move.moonblast": "Pouvoir Lunaire",
  "move.moonlight": "Rayon Lune",
  "move.muddy-water": "Ocroupi",
  "move.mystical-fire": "Feu Ensorcelé",
  "move.nasty-plot": "Machination",
  "move.night-shade": "Ombre Nocturne",
  "move.night-slash": "Tranche-Nuit",
  "move.no-retreat": "Ultime Bastion",
  "move.nuzzle": "Frotte-Frimousse",
  "move.outrage": "Colère",
  "move.overheat": "Surchauffe",
  "move.pain-split": "Balance",
  "move.parabolic-charge": "Parabocharge",
  "move.pay-day": "Jackpot",
  "move.payback": "Représailles",
  "move.peck": "Picpic",
  "move.perish-song": "Requiem",
  "move.petal-dance": "Danse Fleurs",
  "move.phantom-force": "Hantise",
  "move.play-rough": "Câlinerie",
  "move.pollen-puff": "Boule Pollen",
  "move.poltergeist": "Esprit Frappeur",
  "move.pound": "Écras’Face",
  "move.powder-snow": "Poudreuse",
  "move.power-swap": "Permuforce",
  "move.power-up-punch": "Poing Boost",
  "move.power-whip": "Mégafouet",
  "move.psybeam": "Rafale Psy",
  "move.psychic": "Psyko",
  "move.psycho-cut": "Coupe Psycho",
  "move.psyshock": "Choc Psy",
  "move.psystrike": "Frappe Psy",
  "move.pursuit": "Poursuite",
  "move.pyro-ball": "Ballon Brûlant",
  "move.quick-attack": "Vive-Attaque",
  "move.rapid-spin": "Tour Rapide",
  "move.razor-leaf": "Tranch’Herbe",
  "move.recover": "Soin",
  "move.rest": "Repos",
  "move.rock-polish": "Poliroche",
  "move.rock-slide": "Éboulement",
  "move.rock-smash": "Éclate-Roc",
  "move.rock-tomb": "Tomberoche",
  "move.rollout": "Roulade",
  "move.sacred-fire": "Feu Sacré",
  "move.sacred-sword": "Lame Sainte",
  "move.safeguard": "Rune Protect",
  "move.sand-attack": "Jet de Sable",
  "move.sand-tomb": "Tourbi-Sable",
  "move.scald": "Ébullition",
  "move.scratch": "Griffe",
  "move.seed-bomb": "Canon Graine",
  "move.shadow-ball": "Ball’Ombre",
  "move.shadow-claw": "Griffe Ombre",
  "move.shadow-sneak": "Ombre Portée",
  "move.shell-smash": "Exuviation",
  "move.sing": "Berceuse",
  "move.skull-bash": "Coud’Krâne",
  "move.sky-attack": "Piqué",
  "move.slack-off": "Paresse",
  "move.slash": "Tranche",
  "move.sludge-bomb": "Bombe Beurk",
  "move.smack-down": "Anti-Air",
  "move.smart-strike": "Estocorne",
  "move.smokescreen": "Brouillard",
  "move.snarl": "Aboiement",
  "move.snipe-shot": "Tir de Précision",
  "move.soft-boiled": "E-Coque",
  "move.solar-beam": "Lance-Soleil",
  "move.solar-blade": "Lame Solaire",
  "move.spark": "Étincelle",
  "move.spirit-shackle": "Tisse Ombre",
  "move.splash": "Trempette",
  "move.stealth-rock": "Piège de Roc",
  "move.stomp": "Écrasement",
  "move.stone-edge": "Lame de Roc",
  "move.stored-power": "Force Ajoutée",
  "move.stuff-cheeks": "Garde-à-Joues",
  "move.submission": "Sacrifice",
  "move.substitute": "Clonage",
  "move.sucker-punch": "Coup Bas",
  "move.supercell-slam": "Volt Assaut",
  "move.superpower": "Surpuissance",
  "move.surf": "Surf",
  "move.surging-strikes": "Torrent de Coups",
  "move.sweet-kiss": "Doux Baiser",
  "move.sweet-scent": "Doux Parfum",
  "move.swift": "Météores",
  "move.swords-dance": "Danse Lames",
  "move.synthesis": "Synthèse",
  "move.tackle": "Charge",
  "move.tail-whip": "Mimi-Queue",
  "move.tailwind": "Vent Arrière",
  "move.take-down": "Bélier",
  "move.tearful-look": "Larme à l’Œil",
  "move.telekinesis": "Lévikinésie",
  "move.teleport": "Téléport",
  "move.thief": "Larcin",
  "move.throat-chop": "Exécu-Son",
  "move.thunder": "Fatal-Foudre",
  "move.thunder-punch": "Poing Éclair",
  "move.thunder-shock": "Éclair",
  "move.thunder-wave": "Cage Éclair",
  "move.thunderbolt": "Tonnerre",
  "move.trailblaze": "Désherbaffe",
  "move.tri-attack": "Triplattaque",
  "move.trick": "Tour de Magie",
  "move.trick-room": "Distorsion",
  "move.triple-axel": "Triple Axel",
  "move.trop-kick": "Botte Sucrette",
  "move.twister": "Ouragan",
  "move.vine-whip": "Fouet Lianes",
  "move.volt-switch": "Change Éclair",
  "move.volt-tackle": "Électacle",
  "move.water-gun": "Pistolet à O",
  "move.water-pulse": "Vibraqua",
  "move.water-shuriken": "Sheauriken",
  "move.water-spout": "Giclédo",
  "move.waterfall": "Cascade",
  "move.whirlpool": "Siphon",
  "move.wicked-blow": "Poing Obscur",
  "move.wide-guard": "Garde Large",
  "move.wild-charge": "Éclair Fou",
  "move.will-o-wisp": "Feu Follet",
  "move.wing-attack": "Cru-Ailes",
  "move.wish": "Vœu",
  "move.wood-hammer": "Martobois",
  "move.x-scissor": "Plaie Croix",
  "move.yawn": "Bâillement",
  "move.zap-cannon": "Élecanon",
  "move.zen-headbutt": "Psykoud’Boul",
// @end move-names-i18n
  // Battle Items
  "battle-item.potion": "Potion",
  "battle-item.x-attack": "X Attaque",
  "battle-item.x-speed": "X Vitesse",
  "battle-item.fluffy-tail": "Queue Duveteuse",
  "battle-item.eject-button": "Bouton Éjection",
  "battle-item.slow-smoke": "Fumée Ralentissante",
  "battle-item.full-heal": "Guérison Totale",
  "battle-item.goal-getter": "Marqueur",
  "battle-item.shedinja-doll": "Poupée Munja",
  "battle-item.goal-hacker": "Pirate de But",
  // Held Items
  "held-item.leftovers": "Restes",
  "held-item.muscle-band": "Bande Musclée",
  "held-item.scope-lens": "Lentille Optique",
  "held-item.wise-glasses": "Lunettes Savantes",
  "held-item.shell-bell": "Grelot Coquillage",
  "held-item.float-stone": "Pierre Légère",
  "held-item.focus-band": "Bandeau Concentration",
  "held-item.assault-vest": "Veste d’Assaut",
  "held-item.rocky-helmet": "Casque Cogneur",
  "held-item.razor-claw": "Griffe Rasoir",
  "held-item.choice-specs": "Lunettes de Choix",
  "held-item.choice-scarf": "Foulard de Choix",
  "held-item.weakness-policy": "Politique Faiblesse",
  "held-item.big-root": "Grosse Racine",
  "held-item.amulet-coin": "Pièce Amulette",
  "held-item.rusted-sword": "Épée Rouillée",
  "held-item.mewtwonite-x": "Mewtnite X",
  "held-item.mewtwonite-y": "Mewtnite Y",
  "held-item.lucarionite": "Lucariodite",
  "held-item.charizardite-x": "Dracaufite X",
  "held-item.charizardite-y": "Dracaufite Y",
  "held-item.gyaradosite": "Léviatorite",
};

export default fr;
